module.exports = __webpack_public_path__ + "img/human.36863e79.svg";